import React from 'react';

const TrackingInfo = () => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.6339V1.09056C10 0.764402 9.73664 0.5 9.41177 0.5H0.588235C0.263362 0.5 0 0.764402 0 1.09056V9.90944C0 10.2356 0.263362 10.5 0.588235 10.5C0.720759 10.5 0.8494 10.4551 0.953312 10.3725L2.90571 8.82104H7.67543C8.95394 8.82104 10 7.782 10 6.51205V4.6339ZM4.31311 2.47978L5.02022 3.18689L4.33231 3.875H7.5V5.125H4.33231L5.02022 5.81311L4.31311 6.52022L2.64645 4.85355C2.47288 4.67999 2.4536 4.41056 2.58859 4.21569L2.64645 4.14645L4.31311 2.47978Z"
      fill="white"
    />
  </svg>
);

export default TrackingInfo;
